import { render } from "./FilterSidebarInPendingItems.vue?vue&type=template&id=0dd2fadf&scoped=true"
import script from "./FilterSidebarInPendingItems.vue?vue&type=script&lang=js"
export * from "./FilterSidebarInPendingItems.vue?vue&type=script&lang=js"

import "./FilterSidebarInPendingItems.vue?vue&type=style&index=0&id=0dd2fadf&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd2fadf"]])

export default __exports__